import { Button } from "@procision-software/ui";
import { useAppContext } from "~/components/AppContextProvider";
import useKonomi from "react-use-konami";

export const ToggleAdvancedMode = () => {
  const { advancedMode, setAdvancedMode } = useAppContext();
  useKonomi(() => {
    setAdvancedMode(true);
  });
  return (
    advancedMode && (
      <Button
        onClick={() => setAdvancedMode(!advancedMode)}
        variant="secondary"
        outline={!advancedMode}
      >
        Leave Advanced Mode
      </Button>
    )
  );
};
